import React from 'react';

const NotFound = () => (
  <>
    {/* Page Not Found! */}
    <h2 variant="h2">404: page not found!</h2>
  </>
);

export default NotFound;
